import { z } from 'zod';

/** Mirrors the Admin API validation (AdminGlobalDiscountRequest, DB-GD-01 CHECKs); the backend re-checks every rule. */
export const globalDiscountSchema = z
  .object({
    percentOff: z
      .number({ error: 'Enter a percent.' })
      .min(1, 'At least 1%.')
      .max(90, 'At most 90% (the payment gateway cannot charge 0).')
      .refine((value) => Number.isInteger(value * 100), 'At most 2 decimals.'),
    maxDiscountAmount: z
      .number({ error: 'Enter a cap or leave it empty.' })
      .positive('The cap must be more than 0.')
      .nullable(),
    /** datetime-local values (the staff member's local time); converted to UTC at submit. */
    startsAt: z.string().min(1, 'Choose a date and time.'),
    endsAt: z.string().min(1, 'Choose a date and time.'),
    bannerEnabled: z.boolean(),
    bannerTitleEn: z.string().max(100, 'At most 100 characters.'),
    bannerTitleAr: z.string().max(100, 'At most 100 characters.'),
    bannerTextEn: z.string().max(300, 'At most 300 characters.'),
    bannerTextAr: z.string().max(300, 'At most 300 characters.'),
    description: z.string().max(200, 'At most 200 characters.'),
  })
  .superRefine((value, ctx) => {
    if (value.startsAt && value.endsAt && new Date(value.endsAt) <= new Date(value.startsAt))
      ctx.addIssue({
        code: 'custom',
        path: ['endsAt'],
        message: 'The end must be after the start.',
      });
    if (value.bannerEnabled && value.bannerTitleEn.trim() === '')
      ctx.addIssue({
        code: 'custom',
        path: ['bannerTitleEn'],
        message: 'Give the banner an English title.',
      });
    if (value.bannerEnabled && value.bannerTitleAr.trim() === '')
      ctx.addIssue({
        code: 'custom',
        path: ['bannerTitleAr'],
        message: 'Give the banner an Arabic title.',
      });
  });

export type GlobalDiscountFormValues = z.infer<typeof globalDiscountSchema>;
